import { useSimpleIndexContext } from 'modules/billing/components/SimpleIndexPage/contexts';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Menu, MenuItemOption } from 'ui/menu';
import { InputSearch } from 'ui/inputs';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { ALIGNMENT } from 'ui/menu/constants';
import { spacing } from 'ui/theme';
import { getApiKeys } from '../selectors';

const TableActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.half};
`;

export const TABLE_ACTIONS_TEXT = {
  filtersButtonLabel: 'Filters',
  filterInputId: 'table-search-input',
};

export const TableActions = () => {
  const { query, setQuery, filterByValues, toggleFilterByValue } = useSimpleIndexContext();

  const { keyTypes } = useSelector(getApiKeys);

  const handleSelection = (val: string) => {
    toggleFilterByValue('keyType', val);
  };
  const selectedFilters = filterByValues?.keyType || [];

  const filterOptions: MenuItemOption[] = [
    { id: 'key-type', label: 'Key type', isTitle: true },
    ...keyTypes.map((keyType) => ({
      id: keyType.value,
      content: keyType.label,
    })),
  ];

  return (
    <TableActionsWrapper>
      <Menu
        options={filterOptions}
        defaultSelectedOptionIds={selectedFilters}
        handleSelectionChange={handleSelection}
        horizontalAlignment={ALIGNMENT.LEFT}
        isSelectMenu={true}
        hasFilter={false}
      >
        <FilterMenuTriggerButton
          triggerText={TABLE_ACTIONS_TEXT.filtersButtonLabel}
          selectedFilterCount={selectedFilters?.length || 0}
        />
      </Menu>
      <InputSearch
        id={TABLE_ACTIONS_TEXT.filterInputId}
        data-test={TABLE_ACTIONS_TEXT.filterInputId}
        placeholder="Search API Keys"
        value={query}
        onChange={setQuery}
        handleClear={() => {
          setQuery('');
        }}
      />
    </TableActionsWrapper>
  );
};
